<template>
  <div class="media is-borderless is-vcentered">
    <div class="media-left">
      <profile-picture class="is-60x60" :picture="picture" :initials="initials"></profile-picture>
    </div>

    <div class="media-content">
      <h3 class="title is-6">{{ fullName }}</h3>
      <p class="subtitle is-7 has-text-grey">{{ description }}</p>
    </div>

    <div class="media-right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ProfilePicture from "@/shared/components/common/profile/ProfilePicture";

export default {
  name: "ProfileMedia",

  components: {
    ProfilePicture,
  },

  props: ["picture", "firstName", "lastName", "position", "company"],

  computed: {
    fullName() {
      return `${this.firstName} ${this.lastName}`;
    },

    initials() {
      const fi = ((this.firstName && this.firstName[0]) || "").toUpperCase();
      const li = ((this.lastName && this.lastName[0]) || "").toUpperCase();

      return `${fi}${li}`;
    },

    description() {
      const glued = [this.position, this.company].filter(value => !!value);
      return `${glued.join(", ")}`;
    },
  },
};
</script>